var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimerFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.895,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#398aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#69a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#ff488e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc9c7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "convertFaceIcon",
    transform: "translate(-744 -266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 40,
    height: 40,
    transform: "translate(744 266)",
    fill: "rgba(0,0,0,0.38)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M21.082,37.238H7.882A3.727,3.727,0,0,1,4,33.714V5.524A3.727,3.727,0,0,1,7.882,2H23.412L35.059,12.571v6.167a13.732,13.732,0,0,0-3.882-.881V14.333H21.471V5.524H7.882v28.19H18.559a15.048,15.048,0,0,0,2.524,3.524m8.153-17.619L24.965,23.5l4.271,3.876V24.9a4.6,4.6,0,0,1,4.853,4.4,3.309,3.309,0,0,1-.582,1.938l2.135,1.938A6.779,6.779,0,0,0,37,29.31c0-3.876-3.494-7.048-7.765-7.048V19.619m4.271,15.5-4.271-4.052v2.643a4.6,4.6,0,0,1-4.853-4.4,3.309,3.309,0,0,1,.582-1.938l-2.135-1.938a6.779,6.779,0,0,0-1.359,3.876c0,3.876,3.494,7.048,7.765,7.048V39Z",
    transform: "translate(744 266)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerFileIcon);
export default __webpack_public_path__ + "static/media/disclaimerFileIcon.d22f0eb2a4c314e6e9d03242c3c78025.svg";
export { ForwardRef as ReactComponent };